export default {
  dialog: {
    details: {
      title: 'Account details'
    }
  },
  updateUser: {
    label: {
      username: 'Username',
      email: 'Email address',
      roleDescription: 'User role'
    }
  }
};
